import _, { orderBy } from 'lodash';
import { useContext, useMemo, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Label } from 'semantic-ui-react';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';

const statTypes = ['Kill', 'Ace', 'Block', 'OTE', 'NS'];

const MatchPointScoring = ({ showStats, away, home, handleConfirm }) => {

  const { rtType } = showStats ?? []

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info } = sportsSeason_state ?? {}
  const { rosters: teamRosters_season } = teams_info ?? {}

  const [selectedStat, setSelectedStat] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState();

  let updateCaption = 'Pending';

  if (selectedStat && selectedPlayer?.uniformNumber) {
    updateCaption = selectedStat + ' - ' + selectedPlayer?.uniformNumber
  }

  let allowUpdate = false

  switch (selectedStat) {
    case 'OTE':
    case 'NS':
      allowUpdate = selectedStat
      updateCaption = selectedStat
      break;
    default:
      allowUpdate = selectedStat && !_.isEmpty(selectedPlayer)
  }

  const currentRoster = useMemo(() => {
    const { _itemKey: key_away } = away ?? {}
    const { _itemKey: key_home } = home ?? {}
    const teamKey = rtType === 'home' ? key_home : key_away
    const _roster = teamRosters_season?.[teamKey]
    return _roster
      ? orderBy(_roster, [(r) => parseInt(r.uniformNumber, 10)], ['asc'])
      : [];
  }, [teamRosters_season, rtType])

  const handleStatSelect = (e, type) => {
    e.stopPropagation()
    setSelectedStat(type);
  };

  const handlePlayerSelect = (e, player) => {
    e.stopPropagation()
    setSelectedPlayer(selectedPlayer?.uniformNumber === player.uniformNumber ? null : player);
  };

  const handlePlayerConfirm = (e) => {
    e.stopPropagation()
    switch (selectedStat) {
      case 'NS':
      case 'OTE':
        handleConfirm(showStats, { stat: selectedStat });
        break;
      default:
        handleConfirm(showStats, { stat: selectedStat, selectedPlayer: { uniformNumber: selectedPlayer.uniformNumber, firstName: selectedPlayer.firstName, lastName: selectedPlayer.lastName } });
    }
  };

  return (
    <div >
      <div>Confirm</div>
      <div className='mps-1'>
        <Label
          color={allowUpdate ? 'green' : 'grey'}
          onClick={(e) => allowUpdate && handlePlayerConfirm(e)}
          size='small'
        >
          {updateCaption}
        </Label>
      </div>

      <div>Select Point Type</div>
      <div className='mps-5'>
        {statTypes.map((statType) => (
          <Label
            color={selectedStat === statType ? 'blue' : 'grey'}
            onClick={(e) => handleStatSelect(e, statType)}
            size='small'
          >
            {statType}
          </Label>
        ))}
      </div>

      {
        selectedStat !== 'Other Team Error' && selectedStat !== '' && (
          <div>
            <div as="h5">Select Player</div>
            <div className='mps-4'>
              {_.map(currentRoster, (player) => (
                <Label
                  key={player.uniformNumber}
                  color={selectedPlayer?.uniformNumber === player.uniformNumber ? 'green' : 'grey'}
                  onClick={(e) => handlePlayerSelect(e, player)}
                  size='small'
                >
                  {player.uniformNumber}
                </Label>
              ))}
            </div>
          </div>
        )
      }
    </div >
  );
};

export default MatchPointScoring;
